import React, { useState, useEffect } from "react";
// Chakra imports
import {
  HStack,
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  FormControl,
  FormLabel,
  Select,
  Checkbox,
  Switch,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";// Chakra Icons
import { SettingsIcon } from "@chakra-ui/icons";
import { FaEye, FaCreditCard, FaWrench, FaCheckCircle, FaEdit } from "react-icons/fa";
// Custom components
import useGetStocks from "../../hooks/useGetStocks";
import Pagination from "./Pagination";
import EditStock from "../../modals/EditStock";
import { useAuth } from "contexts/auth";


function StocksTable({
  productId = undefined, 
}) {

    const textColor = useColorModeValue("gray.700", "white");
    let navbarIcon = useColorModeValue("gray.500", "gray.200");

    const authUser = useAuth();
    const [ page, setPage ] = useState(1);
    const pageLimit = 10;

    const { isOpen: isOpenEditStock, onOpen: onOpenEditStock, onClose: onCloseEditStock } = useDisclosure();
    const [ toEditStock, setToEditStock ] = useState(null);
    const [ withStocks, setWithStocks ] = useState(true);
    const [ visibleColumns, setVisibleColumns ] = useState({
      "Supplier": true,
      "Quantity": true,
      "Unit Price": true,
      "Selling Price": true,
    });

    let { 
      stocks, 
      totalStocks, 
      setGettingStocks, 
      gettingStocks, 
      gettingStocksReqSuccess 
    } = useGetStocks({ 
      page, 
      limit: pageLimit,
      productId,  
      withStocks: withStocks,
    });


    useEffect(() => {
      reloadTable();
    }, [page, withStocks]);
    
    const reloadTable = () => {
      // console.log(page, withStocks);
      setGettingStocks(true);
    }

    const onChangeVisibleColumn = (columnName, value) => {
      const tmp = {...visibleColumns};
      tmp[columnName] = value;
      setVisibleColumns(tmp);
      // console.log(columnName, value);
    }


    const selectEditStock = (id) => {
      // console.log(id);
      const user = stocks.find((c) => c.id === id);
      // console.log(user.email);
      setToEditStock(user);
      onOpenEditStock(true);
    }

    // console.log(`customerId: ${customerId}`);

    return ( 
        <Flex direction="column" w="100%">
          <Box>
            <Flex direction="row" w="100%">
              <HStack>
                <Text marginLeft={2}>Filter</Text>
                <Select
                defaultValue={'WithStocks'}
                  onChange={(e) => {
                    if (e.target.value == 'All') {
                      setWithStocks(null);
                    }  else if (e.target.value == 'WithStocks') {
                      setWithStocks(true);
                    }
                  }}
                >
                  <option key="status-all" value="All">All</option>
                  <option key="status-withStocks" value="WithStocks">With Stocks</option>
                </Select>
              </HStack>
              <Box flex={1} alignSelf="center" textAlign="right">
                <Menu>
                  <MenuButton>
                    <SettingsIcon color={navbarIcon} w="24px" h="24px" />
                  </MenuButton>
                  <MenuList p="16px 8px" width="80px">
                    <Flex flexDirection="column">
                      { Object.keys(visibleColumns).map((key) => {
                          return (
                            <FormControl display="flex" 
                              alignItems="center" >
                              <FormLabel htmlFor={key} mb="0"
                              width="100%">
                                {key}
                              </FormLabel>
                              <Switch id={key} defaultChecked={visibleColumns[key]}
                                onChange={e => onChangeVisibleColumn(key, e.target.checked)}/>
                            </FormControl>
                          )
                        })
                      }
                    </Flex>
                  </MenuList>
                </Menu>
              </Box>
              
              
            </Flex>
          </Box>
          <Box 
            marginTop={2}
            maxHeight={"74vh"}
            overflowY={"auto"}
          >
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  { visibleColumns["Supplier"] 
                  ? <Th p={2} color="gray.400">Supplier</Th>
                  : null }
                  { visibleColumns["Quantity"] 
                    ? <Th p={2} color="gray.400">Quantity</Th>
                    : null }
                  { visibleColumns["Unit Price"] 
                    ? <Th p={2} color="gray.400">Unit Price</Th>
                    : null }
                  { visibleColumns["Selling Price"] 
                    ? <Th p={2} color="gray.400">Selling Price</Th>
                    : null }
                  <Th p={2} color="gray.400">Actions</Th>
                   
                </Tr>
              </Thead>
              <Tbody>
                {gettingStocks ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : stocks.map((o) => {
                    return (
                      <Tr my=".8rem" p={2} key={`stock-row-${o.id}`}>
                        { visibleColumns["Supplier"] 
                          ? <Td p={2}>
                              <Text>{o.supplier}</Text>
                            </Td>
                          : null
                        }
                        { visibleColumns["Quantity"] 
                          ? <Td  p={2}>
                              <Text>{o.quantity}</Text>
                            </Td>
                          : null 
                        } 
                        { visibleColumns["Unit Price"] 
                          ? <Td  p={2}>
                              <Text>{o.unitPrice}</Text>
                            </Td>
                          : null 
                        }
                        { visibleColumns["Selling Price"] 
                          ? <Td  p={2}>
                            <Text>{o.sellingPrice}</Text>
                          </Td>
                          : null 
                        }
                        <Td  p={2}>
                          <Flex flexDirection="row">
                            
                            {authUser.auth.role != 'auditor'
                            ? <Button 
                              key={`action-${o.id}-view-stock`}
                              p="0px" bg="transparent" 
                              title="Edit Stock"
                              onClick={() => {
                                setToEditStock(o);
                                onOpenEditStock(true);
                              }}
                            >
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaEdit} me="2px" />
                              </Flex>
                            </Button>
                            : null }
                           
                          </Flex>
                        </Td>
                      </Tr>
                    );
                  })
                }
                
              </Tbody>
            </Table>
          </Box>
          <Spacer />
          { totalStocks != 0
            ? <Pagination 
              totalItems={totalStocks}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
            : null
          }

        <EditStock
          isOpen={isOpenEditStock}
          onClose={() => {
            setToEditStock(null);
            onCloseEditStock();
          }}
          successCallback={() => {
            setGettingStocks(true);
          }}
          stockData={toEditStock}
        />
        
        </Flex>
    )
}


export default StocksTable;